var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.name !== 'login')?_c('vue-navigation'):_vm._e(),_c('div',{staticClass:"pt-16 px-4"},[_c('router-view')],1),_c('vue-loading'),_c('vue-uploading'),_c('vue-errors')],1)}
var staticRenderFns = []

export { render, staticRenderFns }